const getTranslations = ({ i18n }) => ({
  ASSIGNED_TEXT: i18n.t`Assigned`,
  VOLUNTARY_TEXT: i18n.t`Voluntary`,
  CURRENT_ASSIGNED_TEXT: i18n.t`Currently Assigned`
});

export default getTranslations;
